import type { PortalAudience } from '@/access/portalAccess.types';
import type { JobsViewInput } from '@/modules/jobs/jobs.viewInput';

export type JobCreationClientQueryStrategy = 'tenantAll' | 'currentUser';

export type JobCreationView = {
  audience: PortalAudience;
  actions: {
    assignWorker: boolean;
    selectClient: boolean;
  };
  sections: {
    questionnaire: boolean;
  };
  query: {
    clients: {
      strategy: JobCreationClientQueryStrategy;
    };
    classifications: {
      fetch: boolean;
    };
    availableWorkers: {
      fetch: boolean;
    };
  };
};

export const getJobCreationView = ({
  access,
  tenantRequiresPostingQuestionnaire,
}: JobsViewInput): JobCreationView => {
  const { audience, canManageTenantJobs, isTenantPortal } = access;

  return {
    audience,
    actions: {
      assignWorker: isTenantPortal && canManageTenantJobs,
      selectClient: isTenantPortal,
    },
    sections: {
      questionnaire: tenantRequiresPostingQuestionnaire,
    },
    query: {
      clients: {
        strategy: isTenantPortal ? 'tenantAll' : 'currentUser',
      },
      classifications: {
        fetch: true,
      },
      availableWorkers: {
        fetch: isTenantPortal && canManageTenantJobs,
      },
    },
  };
};
